__turbopack_context__.v({
  "location": "PhotographersGrid-module__zarwuG__location",
  "name": "PhotographersGrid-module__zarwuG__name",
  "photographer": "PhotographersGrid-module__zarwuG__photographer",
  "photographersGrid": "PhotographersGrid-module__zarwuG__photographersGrid",
  "portrait": "PhotographersGrid-module__zarwuG__portrait",
  "price": "PhotographersGrid-module__zarwuG__price",
  "tagline": "PhotographersGrid-module__zarwuG__tagline",
});
